import React, { useState } from "react"
import { injectIntl } from "react-intl"
import Select from "react-select"
import { Intl } from "../../state/helpers/IntlProps"
import { CREDIT_MEMO_STATUS, generateOptions } from "./CreditMemoStatus"




type OwnProps = {
    intl: Intl
    multi: boolean
    onChange: (selectedOpts: string[], selectedOptsLabels: string) => void
}


const CreditMemoStatusSelect = (props: OwnProps) =>{

    const [selectedOption, setSelectedOption] = useState<CREDIT_MEMO_STATUS | CREDIT_MEMO_STATUS[]>([])
   
   
    const onChangeSelect = (selectedOpts) => {
        setSelectedOption(selectedOpts)
        if (props.multi === true) {
            props.onChange(selectedOpts.map(option => option.value), selectedOpts.map(option => option.label).join(","))
        } else {
            props.onChange(selectedOpts.value, selectedOpts.label)
        }
    }

  
    return <Select
        id="payment-status-select"
        name="payment-status-select"
        multi={props.multi}
        value={selectedOption}
        onChange={onChangeSelect}
        options={generateOptions(props.intl)}
    />
        

}

export default injectIntl(CreditMemoStatusSelect)





// WEBPACK FOOTER //
// ./src/invoice/credit-memo/CreditMemoStatusSelect.tsx